export default __webpack_public_path__ + "static/media/picture.43235b71.svg";